import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22f3993c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "MENIU", -1))
const _hoisted_3 = { id: "items-container" }


import ClosestMenuItem from '@/components/modules/map/ClosestMenuItem.vue';
import MarkerIcon from '@/components/icons/MarkerIcon.vue';
import ReturnButton from '@/components/ui/ReturnButton.vue';
import RecyclingCenterIcon from '@/components/icons/RecyclingCenterIcon.vue';

interface IMenuItem {
	markerColor: string;
	distance: string;
}

interface IMenuProps {
	pins: IMenuItem[];
	recyclingCenter: IMenuItem;
}

interface IMenuEmits {
	(e: 'back'): void;
	(e: 'closest', id: number): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    pins: { type: Array, required: true },
    recyclingCenter: { type: Object, required: true }
  },
  emits: ["back", "closest"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'back'): void;
	(e: 'closest', id: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	pins: IMenuItem[];
	recyclingCenter: IMenuItem;
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.pins, (t, i) => {
        return (_openBlock(), _createBlock(ClosestMenuItem, {
          key: i,
          distance: t.distance,
          markerColor: t.markerColor,
          class: "item-child",
          onClick: ($event: any) => (emit('closest', i + 1))
        }, {
          default: _withCtx(() => [
            _createVNode(MarkerIcon)
          ]),
          _: 2
        }, 1032, ["distance", "markerColor", "onClick"]))
      }), 128)),
      _createVNode(ClosestMenuItem, {
        distance: props.recyclingCenter.distance,
        markerColor: props.recyclingCenter.markerColor,
        class: "item-child",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closest', __props.pins.length + 1)))
      }, {
        default: _withCtx(() => [
          _createVNode(RecyclingCenterIcon)
        ]),
        _: 1
      }, 8, ["distance", "markerColor"]),
      _createVNode(ReturnButton, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('back')))
      })
    ])
  ]))
}
}

})